import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchDoctorsData = createAsyncThunk(
    'doctors/fetchData',
    async ({perPage,countryId="all"}, { rejectWithValue }) => {
        try {
            
            const response = await api.get('/doctors', {
                params: {
                    perPage: perPage,
                    countryId: countryId
                }
            });
            
            const data = response.data;
            return {doctors:data.doctors,teams:data.teams};
        } catch (error) {
            return rejectWithValue(error);
        }

    }
)

export const doctorSlice = createSlice({
    name: "doctors",
    initialState: {
        loading: false,
        error: null,
        doctors: [],
        teams: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchDoctorsData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchDoctorsData.fulfilled, (state, action) => {
                state.loading = false;
                state.doctors = action.payload.doctors;
                state.teams = action.payload.teams;
            })
            .addCase(fetchDoctorsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default doctorSlice.reducer;